export enum EvaluableType {
  Evaluable = "evaluable",
  NotEvaluable = "notEvaluable",
}

export interface SampleError {
  id: string;
  originalId: string;
  description: string;
  evaluableType: EvaluableType;
  ownerId?: string;
  ownerType?: string;
}
